export const environment = {
    production: true,
    environmentName: 'production',
    backendUrl: '',
};
